import {ReactNode} from 'react';
import {AuthLayoutFooter} from './auth-layout-footer';
import {useIsDarkMode} from '@common/ui/themes/use-is-dark-mode';

interface AuthPageProps {
  heading?: ReactNode;
  message?: ReactNode;
  children: ReactNode;
}
export function AuthLayout({heading, children, message}: AuthPageProps) {
  // const {branding} = useSettings();
  const isDarkMode = useIsDarkMode();

  const logo = 'images/logo_new.png';
  const logo_dark = 'images/logo_new.png';

  // console.log('logo', logo)
  return (
    <main
      className="[items-center md:px-10vw flex h-screen flex-col overflow-y-auto bg-none px-[0.875rem] pt-[4.375rem] dark:bg-none"
      // style={{backgroundImage: isDarkMode ? undefined : `url("${authBgSvg}")`}}
    >
      {/* <Link
        to="/"
        className="block flex-shrink-0 m-admib-[2.5rem]"
        aria-label={trans({message: 'Go to homepage'})}
      > */}
      <img
        src={isDarkMode ? logo : logo_dark}
        className="m-auto block h-[3.625rem] w-auto"
        alt=""
      />
      {/* </Link> */}
      <div className="mx-auto w-full max-w-[25rem] rounded-lg bg-paper px-[2.5rem] pb-[2rem] pt-[2.5rem] shadow md:shadow-xl">
        {heading && <h1 className="mb-[1.25rem] text-xl">{heading}</h1>}
        {children}
      </div>
      {<div className="mt-[2.25rem] text-sm"></div>}
      <AuthLayoutFooter />
    </main>
  );
}
